/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IStackItemStyles, IStackStyles } from '@fluentui/react/lib/Stack';
import { CSSProperties } from 'react';

export const getPageStyles = (): Partial<IStackStyles> => {
    return { root: { height: '100%', padding: '1.7rem 2rem 2.3rem 2rem' } };
};

export const getBodyStyles = (): Partial<CSSProperties> => {
    return {
        overflowX: 'hidden',
        overflowY: 'overlay',
        padding: '0 1.75rem',
        margin: '0 -1.75rem 1.625rem -1.75rem',
        flexGrow: 1,
        flexShrink: 1,
    } as any;
};

export const getFooterStyles = (): Partial<IStackItemStyles> => {
    return {
        root: {
            flexDirection: 'row-reverse',
            selectors: {
                '&>div:not(:first-of-type)': {
                    margin: '0 0.75rem',
                },
            },
        },
    };
};

export const getHeaderStyles = (): Partial<IStackItemStyles> => {
    return { root: { paddingTop: '2px', marginBottom: '1.5rem', width: '32rem' } };
};
